/* eslint-disable jsx-a11y/anchor-is-valid */
import Button from 'app/components/Button'
import ConfirmationModal from 'app/components/ConfirmationModal'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import {collection, deleteDoc, doc, getDoc, onSnapshot, updateDoc} from 'firebase/firestore'
import React, {useEffect, useState} from 'react'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import {Link, useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import db from '../../../../services/firebase'
import {useAuth} from '../../../modules/auth'
import {
  calculateDocumentStatus,
  deleteNote,
  deletePlatform,
  deleteTest,
  processControlValues,
} from '../utils/controlUtils'
import {
  useActivities,
  useAudits,
  useControlStatusUpdate,
  useControlTests,
  useLoadControls,
  useUpdateControlDocument,
  useUpdateControlTest,
  getFormattedDateTime,
  handleOwnerAssignment
} from '../utils/controlHooks'
import AddAutomated from './submodal/AddAutomated'
import AddEvidence from './submodal/AddEvidence'
import AddFramework from './submodal/AddFramework'
import AddRiskScenario from './submodal/AddRiskScenario'
import AddTask from './submodal/AddTask'
import UpgradePlanTest from './submodal/UpgradePlanTest'
import {TestStatusBadge} from 'app/pages/tests/components/viewTestsComponents'
import useAuditContext from 'app/Hooks/useAuditContext'

interface ViewControlProps {
  isOpen: boolean
  onClose: () => void
  id: string
}

const ViewControl: React.FC<ViewControlProps> = ({isOpen, onClose, id}) => {
  const [personnels, setPersonnels] = useState<any[]>([])
  const {currentUser} = useAuth()
  const [showAllFrameworks, setShowAllFrameworks] = useState(false)
  const [newOwner, setNewOwner] = useState('')
  const [activeTab, setActiveTab] = useState('overview')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalRisk, setIsModalRisk] = useState(false)
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const [noteInput, setNoteInput] = useState('')
  const [isAdding, setIsAdding] = useState(false)
  const [editingNoteIndex, setEditingNoteIndex] = useState(null)
  const [editedNoteContent, setEditedNoteContent] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [showAutomated, setShowAutomated] = useState(false)
  const [showEvidence, setShowEvidence] = useState(false)
  const navigate = useNavigate()
  const [noteSaving, setNoteSaving] = useState(false)
  const [showModal2, setShowModal2] = useState(false)
  const [isTaskDeleteModalOpen, setIsTaskDeleteModalOpen] = useState(false)
  const [isControlDeleteModalOpen, setIsControlDeleteModalOpen] = useState(false)
  const [selectedTask, setSelectedTask] = useState<any>(null)
  const [selectedRisk, setSelectedRisk] = useState<any>(null)
  const [isDeleting, setIsDeleting] = useState(false)
  const [isNoteDeleteModalOpen, setIsNoteDeleteModalOpen] = useState(false)
  const [isTestDeleteModalOpen, setIsTestDeleteModalOpen] = useState(false)
  const [isPlatformDeleteModalOpen, setIsPlatformDeleteModalOpen] = useState(false)
  const [selectedNoteIndex, setSelectedNoteIndex] = useState<number | null>(null)
  const [selectedTestIndex, setSelectedTestIndex] = useState<number | null>(null)
  const [selectedPlatformIndex, setSelectedPlatformIndex] = useState<number | null>(null)
  const [showDeactivated, setShowDeactivated] = useState(false)
  const {currentAuditContext} = useAuditContext()

  const {tasks, getActivities} = useActivities(currentUser)
  const {audits} = useAudits(currentUser, currentAuditContext)
  const {controls, tests, loadControls} = useLoadControls(id, currentUser)
  const {specificTests, specificdocuments, deactivatedCount} = useControlTests(
    id,
    controls,
    tests,
    showDeactivated
  )
  useControlStatusUpdate(id, controls, currentUser, specificTests, specificdocuments)
  useUpdateControlDocument(id, currentUser, specificdocuments)
  useUpdateControlTest(id, currentUser, specificTests)

  useEffect(() => {
    if (!isOpen) {
      setActiveTab('overview')
    }
  }, [isOpen])

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) {
      return
    }
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'employees')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      const risksData = snapshot.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          end_date: doc.data().end_date,
        }))
        .filter((data) => !data.end_date)
      setPersonnels(risksData)
    })

    return unsubscribe
  }, [currentUser?.tenantId])

  const handleTabClick = (tab) => {
    setActiveTab(tab)
  }

  const handleboard = () => {
    setShowModal(true)
  }

  const handleAutomated = () => {
    setShowAutomated(true)
  }

  const handleCloseAutomated = () => {
    setShowAutomated(false)
  }

  const handleEvidence = () => {
    setShowEvidence(true)
  }

  const handleCloseEvidence = () => {
    setShowEvidence(false)
  }

  const handleOwner = (event) => {
    handleOwnerAssignment(event, id, currentUser, setNewOwner, personnels)
  }

  // Helper function to find personnel data for an owner
  const findPersonnelByOwner = (ownerName) => {
    return personnels.find(person => person.full_name === ownerName)
  }

  const handleNotes = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!noteInput.trim()) {
      return
    }

    const {formattedDate, formattedTime} = getFormattedDateTime()

    try {
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/controls/${id}`)

      const docSnap = await getDoc(testDocRef)
      const currentNotes = docSnap.data()?.notes || []

      const assignedAuditId = currentAuditContext?.auditId || (currentUser?.role === 'Auditor' && audits.length > 0 ? audits[0]?.id : '')
      const newNoteObject = {
        addedUser: currentUser?.userName || 'Unknown User',
        addedUserUid: currentUser?.uid || '',
        addedDate: formattedDate,
        addedTime: formattedTime,
        note: noteInput.trim(),
        auditId: assignedAuditId,
      }
      setIsAdding(true)
      const updatedNotes = [newNoteObject, ...currentNotes]

      await updateDoc(testDocRef, {
        notes: updatedNotes,
      })
      showSuccessToast({message: 'Note added successfully'})
      setNoteInput('')
      setIsAdding(false)
    } catch (error) {
      showErrorToast({message: 'Failed to add note'})
      setIsAdding(false)
    }
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleOpenRisk = () => {
    setIsModalRisk(true)
  }

  const handleCloseRisk = () => {
    setIsModalRisk(false)
  }

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible)
  }

  const handleRemoveTask = (taskId) => {
    setSelectedTask(taskId)
    setIsTaskDeleteModalOpen(true)
  }

  const handleConfirmTaskDelete = async () => {
    try {
      setIsDeleting(true)
      const tenantId = currentUser?.tenantId || ''
      const taskRef = doc(db, 'tenants', tenantId, 'tasklists', selectedTask)
      await deleteDoc(taskRef)
      getActivities()
      showSuccessToast({message: 'Selected items have been removed.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while removing the selected items.'})
    } finally {
      setIsDeleting(false)
      setIsTaskDeleteModalOpen(false)
      setSelectedTask(null)
    }
  }

  const handleDeleteNote = (index: number) => {
    setSelectedNoteIndex(index)
    setIsNoteDeleteModalOpen(true)
  }

  const handleConfirmNoteDelete = async () => {
    try {
      setIsDeleting(true)
      if (selectedNoteIndex === null) return
      await deleteNote(currentUser, id, selectedNoteIndex)
      showSuccessToast({message: 'Note has been deleted successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the note.'})
    } finally {
      setIsDeleting(false)
      setIsNoteDeleteModalOpen(false)
      setSelectedNoteIndex(null)
    }
  }

  const handleDeleteTest = (index: number) => {
    setSelectedTestIndex(index)
    setIsTestDeleteModalOpen(true)
  }

  const handleConfirmTestDelete = async () => {
    try {
      if (selectedTestIndex === null) return
      setIsDeleting(true)
      await deleteTest(currentUser, id, selectedTestIndex)
      showSuccessToast({message: 'Test document has been deleted successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the test document.'})
    } finally {
      setIsDeleting(false)
      setIsTestDeleteModalOpen(false)
      setSelectedTestIndex(null)
    }
  }

  const handleDeletePlatform = (index: number) => {
    setSelectedPlatformIndex(index)
    setIsPlatformDeleteModalOpen(true)
  }

  const handleConfirmPlatformDelete = async () => {
    try {
      setIsDeleting(true)
      if (selectedPlatformIndex === null) return
      await deletePlatform(currentUser, id, selectedPlatformIndex)
      showSuccessToast({message: 'Platform test has been deleted successfully.'})
    } catch (error) {
      showErrorToast({message: 'An error occurred while deleting the platform test.'})
    } finally {
      setIsDeleting(false)
      setIsPlatformDeleteModalOpen(false)
      setSelectedPlatformIndex(null)
    }
  }

  const handleEditNote = (index, currentContent) => {
    setEditingNoteIndex(index)
    setEditedNoteContent(currentContent)
  }

  const handleSaveEditedNote = async () => {
    try {
      setNoteSaving(true)
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/controls/${id}`)

      const docSnap = await getDoc(testDocRef)
      const currentNotes = docSnap.data()?.notes || []

      const updatedNotes = currentNotes.map((note, index) =>
        index === editingNoteIndex ? {...note, note: editedNoteContent} : note
      )

      await updateDoc(testDocRef, {
        notes: updatedNotes,
      })

      setEditingNoteIndex(null)
      setEditedNoteContent('')
      setNoteSaving(false)
    } catch (error) {
      console.error('Error editing note: ', error)
    }
  }

  const handleRiskClick = (riskId) => {
    navigate(`/risk-management?id=${riskId}`)
  }

  const handleDeleteControl = (risk) => {
    setSelectedRisk(risk)
    setIsControlDeleteModalOpen(true)
  }

  const handleConfirmControlDelete = async () => {
    try {
      setIsDeleting(true)
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const riskRef = doc(tenantRef, 'risks', selectedRisk.riskId)
      const controlRef = doc(tenantRef, 'controls', id)

      const riskDoc = await getDoc(riskRef)
      if (riskDoc.exists()) {
        const riskData = riskDoc.data()
        const updatedAddedControls = riskData.added_controls.filter((control) => control.id !== id)
        await updateDoc(riskRef, {
          added_controls: updatedAddedControls,
        })
      }

      const controlDoc = await getDoc(controlRef)
      if (controlDoc.exists()) {
        const controlData = controlDoc.data()
        const updatedRiskScenarios = controlData.risk_scenario.filter(
          (scenario) => scenario.riskId !== selectedRisk.riskId
        )
        await updateDoc(controlRef, {
          risk_scenario: updatedRiskScenarios,
        })
      }
      loadControls()
      showSuccessToast({
        message: `Risk has been removed from the control.`,
      })
    } catch (error) {
      showErrorToast({message: 'An error occurred while removing the risk from the control.'})
    } finally {
      setIsDeleting(false)
      setIsControlDeleteModalOpen(false)
      setSelectedRisk(null)
    }
  }

  return (
    <>
      <AddTask isOpen={isModalOpen} onClose={handleCloseModal} control_id={id} />
      <AddRiskScenario isOpen={isModalRisk} onCancel={handleCloseRisk} controlId={id} />
      <Drawer open={isOpen} onClose={onClose} direction='right' className='' size='45%'>
        <div
          className='border-bottom border-gray-300'
          style={{
            position: 'sticky',
            top: 0,
            backgroundColor: 'white',
            padding: '14px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            paddingLeft: '15px',
            paddingRight: '12px',
          }}
        >
          <div className='d-flex justify-content-between w-100'>
            {controls
              .filter((control) => control.id === id)
              .map((control) => (
                <span className='modal-title mt-2 fs-4 fw-bold mx-2' key={control.id}>
                  {control.control_title}
                </span>
              ))}

            <div className='d-flex align-items-center'>
              {(currentUser?.role !== 'Auditor' && !currentAuditContext) && (
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary'
                  style={{
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    if (e.currentTarget) {
                      e.currentTarget.style.backgroundColor = '#fff'
                      const svgElement = e.currentTarget.querySelector('svg')
                      if (svgElement) {
                        svgElement.style.stroke = '#0E9F6E'
                      }
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (e.currentTarget) {
                      e.currentTarget.style.backgroundColor = '#fff'
                      const svgElement = e.currentTarget.querySelector('svg')
                      if (svgElement) {
                        svgElement.style.stroke = '#5A5A5A'
                      }
                    }
                  }}
                >
                  <a href={`/controls/details/${id}`} target='_blank' rel='noopener noreferrer'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='20'
                      height='20'
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='#5A5A5A'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      className='icon icon-tabler icons-tabler-outline icon-tabler-external-link'
                    >
                      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                      <path d='M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6' />
                      <path d='M11 13l9 -9' />
                      <path d='M15 4h5v5' />
                    </svg>
                  </a>
                </div>
              )}
              <div
                className='btn btn-icon btn-sm btn-active-light-primary'
                aria-label='Close'
                onClick={onClose}
                style={{
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  if (e.currentTarget) {
                    e.currentTarget.style.backgroundColor = '#fff'
                    const svgElement = e.currentTarget.querySelector('svg')
                    if (svgElement) {
                      svgElement.style.stroke = '#0E9F6E'
                    }
                  }
                }}
                onMouseLeave={(e) => {
                  if (e.currentTarget) {
                    e.currentTarget.style.backgroundColor = '#fff'
                    const svgElement = e.currentTarget.querySelector('svg')
                    if (svgElement) {
                      svgElement.style.stroke = '#5A5A5A'
                    }
                  }
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='20'
                  height='20'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='#5E6274'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  className='icon icon-tabler icons-tabler-outline icon-tabler-x '
                >
                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                  <path d='M18 6l-12 12' />
                  <path d='M6 6l12 12' />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <AddFramework id={id || ''} isOpen={showModal} onClose={handleCloseModal} />
        <AddAutomated id={id || ''} isOpen={showAutomated} onClose={handleCloseAutomated} />
        <AddEvidence id={id || ''} isOpen={showEvidence} onClose={handleCloseEvidence} />

        <div
          className='px-7 pt-6 scroll-y overflow-auto '
          tabIndex={-1}
          style={{height: 'calc(100vh - 40px)'}}
        >
          {controls
            .filter((control) => control.id === id)
            .map((control) => (
              <div key={control.id}>
                <div className='modal-body '>
                  <div
                    className='d-flex flex-column'
                    id='kt_modal_add_user_scroll'
                    data-kt-scroll='true'
                    data-kt-scroll-activate='{default: false, lg: true}'
                    data-kt-scroll-max-height='auto'
                    data-kt-scroll-dependencies='#kt_modal_add_user_header'
                    data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
                    data-kt-scroll-offset='300px'
                  >
                    <div
                      className='fv-row mb-4 text-gray-800 fs-6'
                      dangerouslySetInnerHTML={{__html: control.control_description}}
                    />

                    <div className='row mb-5'>
                      <div className='col-3'>
                        <label className='text-gray-800 fw-semibold me-2 fs-6 '>Author</label>
                      </div>
                      <div className='col-9'>
                        <span className='fw-normal fw-semibold fs-6'>
                          {control.author ? control.author : 'SecureSlate'}
                        </span>
                      </div>
                    </div>

                    <div className='row mb-2'>
                      <div className='col-3'>
                        <label className='text-gray-800 fw-semibold me-2 fs-6'>Framework</label>
                      </div>
                      <div className='col-9'>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className='d-flex flex-wrap align-items-center mb-4'>
                            <div className=''>
                              {control.control_framework_mappings &&
                              typeof control.control_framework_mappings === 'string' ? (
                                <span
                                  className='badge px-3 rounded-pill me-1 fs-7'
                                  style={{border: '2px solid #E1E1E1'}}
                                >
                                  {control.control_framework_mappings.split(',')[0].trim()}{' '}
                                </span>
                              ) : (
                                '--'
                              )}
                            </div>
                            {control.control_framework_mappings &&
                              typeof control.control_framework_mappings === 'string' &&
                              control.control_framework_mappings.split(',').length > 1 &&
                              !showAllFrameworks && (
                                <button
                                  className='btn btn-link p-0 '
                                  onClick={() => setShowAllFrameworks(true)}
                                >
                                  <span
                                    className='badge px-3 rounded-pill fs-7'
                                    style={{border: '2px solid #E1E1E1'}}
                                  >
                                    +{control.control_framework_mappings.split(',').length - 1}
                                  </span>
                                </button>
                              )}

                            {showAllFrameworks &&
                              control.control_framework_mappings &&
                              typeof control.control_framework_mappings === 'string' && (
                                <>
                                  {control.control_framework_mappings
                                    .split(',')
                                    .slice(1)
                                    .map((framework, index) => (
                                      <span
                                        key={index}
                                        className='badge px-3 rounded-pill me-1 fs-7 mb-1'
                                        style={{border: '2px solid #E1E1E1'}}
                                      >
                                        {framework.trim()}
                                      </span>
                                    ))}
                                </>
                              )}
                          </div>

                          {control.author === 'Custom Control' && currentUser?.role !== 'Auditor' && (
                            <button
                              className='btn btn-sm p-0 fs-6 mb-4'
                              style={{color: '#0E9F6E'}}
                              onClick={handleboard}
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='16'
                                height='16'
                                viewBox='0 0 24 24'
                                fill='none'
                                stroke='currentColor'
                                stroke-width='2'
                                stroke-linecap='round'
                                stroke-linejoin='round'
                                className='icon icon-tabler icons-tabler-outline icon-tabler-edit me-1 mb-1'
                              >
                                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                                <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                                <path d='M16 5l3 3' />
                              </svg>
                              Edit
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className='row mb-4'>
                      <div className='col-3'>
                        <label className='text-gray-800 fw-semibold me-2 fs-6'>Status</label>
                      </div>
                      <div className='col-9'>
                        <span className='fw-normal fw-bold fs-6'>
                          {control.control_evidence_status === 'Deactivated' ? (
                            <a
                              href='#'
                              className='badge fs-7 text-dark text-bold'
                              style={{background: '#F6F6F6'}}
                            >
                              {control.control_evidence_status}
                            </a>
                          ) : (
                            <a
                              className={`badge fs-7 ${
                                control.control_evidence_status === 'Ok' ||
                                control.control_evidence_status === 'OK'
                                  ? 'badge-primary'
                                  : 'badge-danger'
                              }`}
                              style={{
                                color:
                                  control.control_evidence_status === 'Ok' ||
                                  control.control_evidence_status === 'OK'
                                    ? '#0E9F6E'
                                    : '#EE3043',
                                background:
                                  control.control_evidence_status === 'Ok' ||
                                  control.control_evidence_status === 'OK'
                                    ? '#E8F8F4'
                                    : '#FFF5F8',
                              }}
                              href='#'
                            >
                              {control.control_evidence_status}
                            </a>
                          )}{' '}
                          <span className='mx-1'> </span>
                          <span className='fs-6 fw-semibold'>
                            {' '}
                            {processControlValues(
                              control.control_document,
                              control.control_test,
                              control.test_id,
                              control.document_id,
                              tests
                            )}{' '}
                            Test Passing
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-3 d-flex align-items-center'>
                        <label className='fs-6 text-gray-800 fw-semibold me-4'>Owner</label>
                      </div>
                      <div className='col-9'>
                        <span className='fw-normal'>
                          {' '}
                          <select
                            name='group'
                            className='form-select w-40 py-2 px-4'
                            data-control='select2'
                            data-placeholder='Select Group'
                            value={newOwner || control.control_owner}
                            onChange={handleOwner}
                            disabled={currentUser?.role === 'Auditor' || !!currentAuditContext}
                          >
                            <option value='' defaultChecked>
                              Assign Owner
                            </option>
                            {personnels
                              .filter((user) => user.role === 'Admin' || user.role === 'Owner')
                              .map((group) => (
                                <option key={group.id} value={group.full_name}>
                                  {group.full_name}
                                </option>
                              ))}
                          </select>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className='separator border-3 my-8'></div> */}

                <div className='px-2  mt-4 mb-8'>
                  <div className='d-flex  h-55px'>
                    <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap '>
                      <li className='nav-item'>
                        <Link
                          to={``}
                          className={`nav-link me-6 ${
                            activeTab === 'overview' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('overview')}
                        >
                          Tests
                        </Link>
                      </li>

                      <li className='nav-item'>
                        <Link
                          to={''}
                          className={`nav-link me-6 ${
                            activeTab === 'risks' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('risks')}
                        >
                          Risks
                        </Link>
                      </li>

                      <li className='nav-item'>
                        <Link
                          to={''}
                          className={`nav-link me-6 ${
                            activeTab === 'notes' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('notes')}
                        >
                          Notes
                        </Link>
                      </li>
                      {/* <li className='nav-item'>
                        <Link
                          to={'/controls'}
                          className={`nav-link me-6 ${
                            activeTab === 'tasks' ? 'text-active-primary active' : ''
                          }`}
                          onClick={() => handleTabClick('tasks')}
                        >
                          Tasks
                        </Link>
                      </li> */}
                    </ul>
                  </div>
                </div>

                {activeTab === 'overview' && (
                  <div className='modal-footer mb-4'>
                    <div className=' w-100'>
                      {deactivatedCount > 0 && (
                        <div
                          className='card'
                          style={{
                            backgroundColor: 'oklch(98.5% 0.002 247.839)',
                            border: '0.2px solid rgb(169, 172, 176)',
                            marginBottom: '24px',
                          }}
                        >
                          <div className='px-6 py-4'>
                            <div className='d-flex align-items-between justify-content-between'>
                              <div className='d-flex justify-content-center align-content-center flex-column gap-1'>
                                <span className='card-label  fs-6'>
                                  {' '}
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='20'
                                    height='20'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                    stroke='#5E6274'
                                    stroke-width='2'
                                    stroke-linecap='round'
                                    stroke-linejoin='round'
                                    className='icon icon-tabler icons-tabler-outline icon-tabler-clock-pause me-3'
                                  >
                                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                    <path d='M20.942 13.018a9 9 0 1 0 -7.909 7.922' />
                                    <path d='M12 7v5l2 2' />
                                    <path d='M17 17v5' />
                                    <path d='M21 17v5' />
                                  </svg>
                                  {deactivatedCount}{' '}
                                  {deactivatedCount === 1 ? 'test is' : 'tests are'} deactivated
                                </span>
                              </div>

                              <div className='d-flex align-items-center gap-2'>
                                <div className='form-check form-switch d-flex align-items-center gap-2'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    role='switch'
                                    id='showDeactivated'
                                    style={{
                                      cursor: 'pointer',
                                      width: '36px',
                                      height: '20px',
                                      backgroundColor: showDeactivated ? '#0E9F6E' : '#E4E6EF',
                                      borderColor: showDeactivated ? '#0E9F6E' : '#E4E6EF',
                                      marginTop: '0',
                                    }}
                                    onChange={(e) => setShowDeactivated(e.target.checked)}
                                  />
                                  <span className='fs-7'>Show Deactivated</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className='d-flex justify-content-between align-items-center fw-bold fs-6 mb-6'>
                        <span>
                          Platform{' '}
                          <span className='text-gray-800 fw-semibold fs-8'>
                            {(() => {
                              const status = calculateDocumentStatus(specificTests, control.test_id)
                              return status === '0/0' || status === ' N/A '
                                ? ' (N/A) '
                                : `(${status} OK)`
                            })()}
                          </span>
                        </span>
                        {control.author === 'Custom Control' && currentUser?.role !== 'Auditor' && (
                          <button
                            className='btn btn-sm fs-6'
                            onClick={handleAutomated}
                            onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                              (e.currentTarget.style.backgroundColor = '#148363')
                            }
                            onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                              (e.currentTarget.style.backgroundColor = '#0E9F6E')
                            }
                            style={{
                              backgroundColor: '#0E9F6E',
                              color: '#fff',
                              height: '40px',
                              borderRadius: '4px',
                              transition: 'background-color 0.3s',
                            }}
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='18'
                              height='18'
                              viewBox='0 0 24 24'
                              fill='none'
                              stroke='currentColor'
                              stroke-width='2'
                              stroke-linecap='round'
                              stroke-linejoin='round'
                              className='icon icon-tabler icons-tabler-outline icon-tabler-plus me-1 mb-1'
                            >
                              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                              <path d='M12 5l0 14' />
                              <path d='M5 12l14 0' />
                            </svg>
                            Add
                          </button>
                        )}
                      </div>

                      {(() => {
                        const docStatus = calculateDocumentStatus(specificTests, control.test_id)
                        return !showDeactivated &&
                          (docStatus === ' N/A ' || docStatus === '0/0') ? (
                          <>
                            <div className={`card mb-5 mb-xl-8 `}>
                              <div className='card-header border-0 pt-6 mb-5'>
                                <div className='d-flex align-items-center justify-content-center w-100 fw-bold'>
                                  No platform tests required for this control
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {specificTests.length > 0 ? (
                              specificTests.map((test, index) => (
                                <div
                                  className='card mb-5 mb-xl-8'
                                  key={index}
                                  style={{
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.1)';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                  }}   
                                >
                                  <div className='card-header border-0 pt-6 mb-5'>
                                    <div className='d-flex align-items-center'>
                                      <div
                                        onClick={() => {
                                          if (currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus') {
                                            window.open(`/tests?id=${test.id}`, '_blank')
                                          } else {
                                            setShowModal2(true)
                                          }
                                        }}
                                        style={{cursor: 'pointer'}}
                                      >
                                        <div className='d-flex justify-content-start flex-column'>
                                          <div className='mb-2' style={{maxWidth: '500px'}}>
                                            <span
                                              className='card-label text-dark text-hover-primary fw-bold fs-6'
                                              style={{
                                                wordWrap: 'break-word',
                                                wordBreak: 'break-word',
                                                display: 'block',
                                                lineHeight: '1.4',
                                                maxHeight: '2em',
                                              }}
                                            >
                                              {test.name}
                                            </span>
                                          </div>

                                          <span className='text-gray-800 fw-semibold fs-7 d-flex align-items-center my-2'>
                                            Owner:{' '}
                                            <div className='symbol symbol-20px me-1 '>
                                               {(() => {
                                              const ownerPersonnel = findPersonnelByOwner(test.owner)
                                              return ownerPersonnel ? (
                                                <div className='symbol symbol-25px mx-1'>
                                                  {ownerPersonnel.image_url ? (
                                                    <img
                                                      src={ownerPersonnel.image_url}
                                                      alt={ownerPersonnel.full_name}
                                                      className='symbol-label fs-7 fw-bold'
                                                      style={{
                                                        objectFit: 'cover',
                                                        width: '25px',
                                                        height: '25px'
                                                      }}
                                                    />
                                                  ) : (
                                                    <span
                                                      className='symbol-label fs-7 fw-bold'
                                                      style={{
                                                        backgroundColor: '#F5F5F5',
                                                        border: '1px solid #E5E5E5',
                                                      }}
                                                    >
                                                      {ownerPersonnel.full_name
                                                        ? ownerPersonnel.full_name.charAt(0).toUpperCase()
                                                        : ''}
                                                    </span>
                                                  )}
                                                </div>
                                              ) : test.owner ? (
                                                <div className='symbol symbol-25px mx-1'>
                                                  <span
                                                    className='symbol-label fs-7 fw-bold'
                                                    style={{
                                                      backgroundColor: '#F5F5F5',
                                                      border: '1px solid #E5E5E5',
                                                    }}
                                                  >
                                                    {test.owner.charAt(0).toUpperCase()}
                                                  </span>
                                                </div>
                                              ) : null
                                            })()}
                                            </div>
                                            <span className='fw-semibold mx-1'>
                                              {test.owner ? test.owner : 'Not assigned'} |{' '}
                                            </span>
                                            
                                            {(currentUser?.role === 'Auditor' || currentAuditContext) ? (
                                              <span className='fw-normal fs-6 ms-1'>
                                                <TestStatusBadge
                                                  status={test.status}
                                                  auditorReview={test.auditor_review}
                                                  isAuditor={true}
                                                  auditId={audits[0]?.id}
                                                />
                                              </span>
                                            ) : (
                                              <span className='fw-normal fs-6 ms-1'>
                                                <TestStatusBadge
                                                  status={test.status}
                                                  isAuditor={false}
                                                />
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-flex justify-content-end'>
                                      {' '}
                                      {control.author !== 'Custom Control' ? (
                                        <div
                                          onClick={() => {
                                            if (currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus') {
                                              window.open(`/tests?id=${test.id}`, '_blank')
                                            }
                                          }}
                                          className='mt-4'
                                          style={{cursor: 'pointer'}}
                                        >
                                          <img
                                            src={toAbsoluteUrl(`/media/buttons/Chevron Button.svg`)}
                                            alt=''
                                          />
                                        </div>
                                      ) : (
                                        <div className='dropdown'>
                                          <button
                                            className='btn btn-secondary border-0 p-0 m-2'
                                            type='button'
                                            id='dropdownMenu2'
                                            data-bs-toggle='dropdown'
                                            aria-haspopup='true'
                                            aria-expanded='false'
                                          >
                                            <img
                                              src='/media/buttons/Options.svg'
                                              alt='Options'
                                              onClick={toggleDropdown}
                                            />
                                          </button>
                                          <ul
                                            className='dropdown-menu dropdown-menu-end'
                                            aria-labelledby='dropdownMenu2'
                                          >
                                            <li>
                                              <a
                                                className='dropdown-item text-muted text-hover-primary '
                                                type='button'
                                                // onClick={() => handleEditNote(index, note.note)}
                                                href={`/tests?id=${test.id}`}
                                              >
                                                <svg
                                                  xmlns='http://www.w3.org/2000/svg'
                                                  width='18'
                                                  height='18'
                                                  viewBox='0 0 24 24'
                                                  fill='none'
                                                  stroke='currentColor'
                                                  stroke-width='2'
                                                  stroke-linecap='round'
                                                  stroke-linejoin='round'
                                                  className='icon icon-tabler icons-tabler-outline icon-tabler-eye mx-2 mb-1'
                                                >
                                                  <path
                                                    stroke='none'
                                                    d='M0 0h24v24H0z'
                                                    fill='none'
                                                  />
                                                  <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                                                  <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                                                </svg>
                                                View
                                              </a>
                                            </li>
                                            <li>
                                              <button
                                                className='dropdown-item text-danger'
                                                type='button'
                                                onClick={() => handleDeletePlatform(index)}
                                              >
                                                <svg
                                                  xmlns='http://www.w3.org/2000/svg'
                                                  width='18'
                                                  height='18'
                                                  viewBox='0 0 24 24'
                                                  fill='none'
                                                  stroke='currentColor'
                                                  stroke-width='2'
                                                  stroke-linecap='round'
                                                  stroke-linejoin='round'
                                                  className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-2 mb-1'
                                                >
                                                  <path
                                                    stroke='none'
                                                    d='M0 0h24v24H0z'
                                                    fill='none'
                                                  />
                                                  <path d='M4 7l16 0' />
                                                  <path d='M10 11l0 6' />
                                                  <path d='M14 11l0 6' />
                                                  <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                                  <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                                </svg>
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <>
                                <div className={`card mb-5 mb-xl-8 `}>
                                  <div className='card-header border-0 pt-6 mb-5'>
                                    <div className='d-flex align-items-center justify-content-center w-100 fw-bold'>
                                      No platform tests required for this control
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )
                      })()}

                      <div className='separator my-5'></div>

                      <div className='d-flex justify-content-between align-items-center fw-bold fs-6 mb-6'>
                        <span>
                          Document{' '}
                          <span className='text-gray-800 fw-semibold fs-8'>
                            {(() => {
                              const status = calculateDocumentStatus(
                                specificdocuments,
                                control.document_id
                              )
                              return status === '0/0' || status === ' N/A '
                                ? ' (N/A) '
                                : `(${status} OK)`
                            })()}
                          </span>
                        </span>
                        {control.author === 'Custom Control' && currentUser?.role !== 'Auditor' && (
                          <button
                            className='btn btn-sm fs-6'
                            onClick={handleEvidence}
                            onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                              (e.currentTarget.style.backgroundColor = '#148363')
                            }
                            onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                              (e.currentTarget.style.backgroundColor = '#0E9F6E')
                            }
                            style={{
                              backgroundColor: '#0E9F6E',
                              color: '#fff',
                              height: '40px',
                              borderRadius: '4px',
                              transition: 'background-color 0.3s',
                            }}
                          >
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='18'
                              height='18'
                              viewBox='0 0 24 24'
                              fill='none'
                              stroke='currentColor'
                              stroke-width='2'
                              stroke-linecap='round'
                              stroke-linejoin='round'
                              className='icon icon-tabler icons-tabler-outline icon-tabler-plus me-1 mb-1'
                            >
                              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                              <path d='M12 5l0 14' />
                              <path d='M5 12l14 0' />
                            </svg>
                            Add
                          </button>
                        )}
                      </div>
                      {(() => {
                        const docStatus = calculateDocumentStatus(
                          specificdocuments,
                          control.document_id
                        )
                        return !showDeactivated &&
                          (docStatus === ' N/A ' || docStatus === '0/0') ? (
                          <>
                            <div className={`card mb-5 mb-xl-8 `}>
                              <div className='card-header border-0 pt-6 mb-5'>
                                <div className='d-flex align-items-center justify-content-center w-100 fw-bold'>
                                  No document tests required for this control
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            {specificdocuments.length > 0 ? (
                              specificdocuments.map((test, index) => (
                                <div
                                  className={`card mb-5 mb-xl-8`}
                                  style={{
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.1)';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                  }}                                  
                                >
                                  <div className='card-header border-0 pt-6 mb-5'>
                                    <div className='d-flex align-items-center'>
                                      <div
                                        onClick={() => {
                                          if (currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus') {
                                            window.open(`/tests?id=${test.id}`, '_blank')
                                          } else {
                                            setShowModal2(true)
                                          }
                                        }}
                                        style={{cursor: 'pointer'}}
                                      >
                                        <div className='d-flex justify-content-start flex-column'>
                                          <div className='mb-2' style={{maxWidth: '500px'}}>
                                            <span
                                              className='card-label text-dark text-hover-primary fw-bold fs-6'
                                              style={{
                                                wordWrap: 'break-word',
                                                wordBreak: 'break-word',
                                                display: 'block',
                                                lineHeight: '1.4',
                                                maxHeight: '2em',
                                              }}
                                            >
                                              {test.name}
                                            </span>
                                          </div>

                                          <span className='text-gray-800 fw-semibold fs-7 d-flex align-items-center my-2'>
                                            Owner:{' '}
                                            <div className='symbol symbol-20px me-1 '>
                                            {(() => {
                                              const ownerPersonnel = findPersonnelByOwner(test.owner)
                                              return ownerPersonnel ? (
                                                <div className='symbol symbol-25px mx-1'>
                                                  {ownerPersonnel.image_url ? (
                                                    <img
                                                      src={ownerPersonnel.image_url}
                                                      alt={ownerPersonnel.full_name}
                                                      className='symbol-label fs-7 fw-bold'
                                                      style={{
                                                        objectFit: 'cover',
                                                        width: '25px',
                                                        height: '25px'
                                                      }}
                                                    />
                                                  ) : (
                                                    <span
                                                      className='symbol-label fs-7 fw-bold'
                                                      style={{
                                                        backgroundColor: '#F5F5F5',
                                                        border: '1px solid #E5E5E5',
                                                      }}
                                                    >
                                                      {ownerPersonnel.full_name
                                                        ? ownerPersonnel.full_name.charAt(0).toUpperCase()
                                                        : ''}
                                                    </span>
                                                  )}
                                                </div>
                                              ) : test.owner ? (
                                                <div className='symbol symbol-25px mx-1'>
                                                  <span
                                                    className='symbol-label fs-7 fw-bold'
                                                    style={{
                                                      backgroundColor: '#F5F5F5',
                                                      border: '1px solid #E5E5E5',
                                                    }}
                                                  >
                                                    {test.owner.charAt(0).toUpperCase()}
                                                  </span>
                                                </div>
                                              ) : null
                                            })()}
                                            </div>
                                             <span className='fw-semibold mx-1'>
                                              {' '}
                                              {test.owner ? test.owner : 'Not assigned'}{' '}
                                            </span>
                                            |{' '}
                                            {(currentUser?.role === 'Auditor' || currentAuditContext) ? (
                                              <span className='fw-normal fs-6 ms-2'>
                                                <TestStatusBadge
                                                  status={test.status}
                                                  auditorReview={test.auditor_review}
                                                  isAuditor={true}
                                                  auditId={audits[0]?.id}
                                                />
                                              </span>
                                            ) : (
                                              <span className='fw-normal fs-6 ms-2'>
                                                <TestStatusBadge
                                                  status={test.status}
                                                  isAuditor={false}
                                                />
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-flex justify-content-end'>
                                      {control.author !== 'Custom Control' ? (
                                        <div
                                          onClick={() => {
                                            if (currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus') {
                                              window.open(`/tests?id=${test.id}`, '_blank')
                                            }
                                          }}
                                          className='mt-4'
                                          style={{cursor: 'pointer'}}
                                        >
                                          <img
                                            src={toAbsoluteUrl(`/media/buttons/Chevron Button.svg`)}
                                            alt=''
                                          />
                                        </div>
                                      ) : (
                                        <div className='dropdown'>
                                          <button
                                            className='btn btn-secondary border-0 p-0 m-2'
                                            type='button'
                                            id='dropdownMenu2'
                                            data-bs-toggle='dropdown'
                                            aria-haspopup='true'
                                            aria-expanded='false'
                                          >
                                            <img
                                              src='/media/buttons/Options.svg'
                                              alt='Options'
                                              onClick={toggleDropdown}
                                            />
                                          </button>
                                          <ul
                                            className='dropdown-menu dropdown-menu-end'
                                            aria-labelledby='dropdownMenu2'
                                          >
                                            <li>
                                              <a
                                                className='dropdown-item text-muted text-hover-primary '
                                                type='button'
                                                href={`/tests?id=${test.id}`}
                                              >
                                                <svg
                                                  xmlns='http://www.w3.org/2000/svg'
                                                  width='18'
                                                  height='18'
                                                  viewBox='0 0 24 24'
                                                  fill='none'
                                                  stroke='currentColor'
                                                  stroke-width='2'
                                                  stroke-linecap='round'
                                                  stroke-linejoin='round'
                                                  className='icon icon-tabler icons-tabler-outline icon-tabler-eye mx-2 mb-1'
                                                >
                                                  <path
                                                    stroke='none'
                                                    d='M0 0h24v24H0z'
                                                    fill='none'
                                                  />
                                                  <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                                                  <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                                                </svg>
                                                View
                                              </a>
                                            </li>
                                            <li>
                                              <button
                                                className='dropdown-item text-danger'
                                                type='button'
                                                onClick={() => handleDeleteTest(index)}
                                              >
                                                <svg
                                                  xmlns='http://www.w3.org/2000/svg'
                                                  width='18'
                                                  height='18'
                                                  viewBox='0 0 24 24'
                                                  fill='none'
                                                  stroke='currentColor'
                                                  stroke-width='2'
                                                  stroke-linecap='round'
                                                  stroke-linejoin='round'
                                                  className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-2 mb-1'
                                                >
                                                  <path
                                                    stroke='none'
                                                    d='M0 0h24v24H0z'
                                                    fill='none'
                                                  />
                                                  <path d='M4 7l16 0' />
                                                  <path d='M10 11l0 6' />
                                                  <path d='M14 11l0 6' />
                                                  <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                                  <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                                </svg>
                                                Delete
                                              </button>
                                            </li>
                                          </ul>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <>
                                {' '}
                                <div className={`card mb-5 mb-xl-8 `}>
                                  <div className='card-header border-0 pt-6 mb-5'>
                                    <div className='d-flex align-items-center justify-content-center w-100 fw-bold'>
                                      No document tests required for this control
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )
                      })()}
                    </div>
                  </div>
                )}

                {activeTab === 'notes' && (
                  <>
                    <div className='mb-15' style={{paddingBottom: '30px'}}>
                      {controls && controls.length > 0 ? (
                        controls.map((control) => {
                          const filteredNotes = control.notes ? control.notes.filter((note) => {
                            if (currentAuditContext?.auditId) {
                              return note.auditId === currentAuditContext.auditId
                            }
                            if (currentUser?.role === 'Auditor' && audits.length > 0) {
                              return note.auditId === audits[0]?.id
                            }
                            return !note.auditId
                          }) : []
                          
                          return filteredNotes.length > 0 ? (
                            filteredNotes.map((note, index) => (
                              <div className='mt-4 mb-8' key={index}>
                                <div className='d-flex align-items-center justify-content-between mb-2'>
                                  <div className='d-flex align-items-center'>
                                    <div className='symbol symbol-35px me-3'>
                                      {note.addedUser ? (
                                        <span
                                          className='symbol-label fs-7 fw-bold'
                                          style={{
                                            backgroundColor: '#F5F5F5',
                                            border: '1px solid #E5E5E5',
                                            borderRadius: '50%',
                                          }}
                                        >
                                          {note.addedUser
                                            ? note.addedUser.trim().charAt(0).toUpperCase()
                                            : ''}
                                        </span>
                                      ) : (
                                        <span>-</span>
                                      )}
                                    </div>

                                    <div className='d-flex flex-column'>
                                      {(() => {
                                        const personnel = personnels.find(
                                          (p) =>
                                            p.id === note.addedUserUid ||
                                            p.uid === note.addedUserUid
                                        )
                                        return (
                                          <span className='text-dark fw-bold fs-6'>
                                            {note.addedUser}
                                            {personnel && personnel.role && (
                                              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                                                {personnel.role}
                                              </span>
                                            )}
                                          </span>
                                        )
                                      })()}
                                      <span className='text-gray-600 fw-semibold text-muted d-block fs-7'>
                                        {note.addedDate} {note.addedTime}
                                      </span>
                                    </div>
                                  </div>

                                  <div className='dropdown'>
                                    {currentUser?.uid === note?.addedUserUid && (
                                      <button
                                        className='btn btn-secondary border-0 p-0 m-2'
                                        type='button'
                                        id='dropdownMenu2'
                                        data-bs-toggle='dropdown'
                                        aria-haspopup='true'
                                        aria-expanded='false'
                                      >
                                        <img
                                          src='/media/buttons/Options.svg'
                                          alt='Options'
                                          onClick={toggleDropdown}
                                        />
                                      </button>
                                    )}
                                    <ul
                                      className='dropdown-menu dropdown-menu-end'
                                      aria-labelledby='dropdownMenu2'
                                    >
                                      <li>
                                        <button
                                          className='dropdown-item text-hover-primary'
                                          type='button'
                                          style={{color: '#262626'}}
                                          onClick={() => handleEditNote(index, note.note)}
                                        >
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='18'
                                            height='18'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='currentColor'
                                            stroke-width='2'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                            className='icon icon-tabler icons-tabler-outline icon-tabler-edit mx-2 mb-1'
                                          >
                                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                            <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                                            <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                                            <path d='M16 5l3 3' />
                                          </svg>
                                          Edit
                                        </button>
                                      </li>
                                      <li>
                                        <button
                                          className='dropdown-item text-danger'
                                          type='button'
                                          onClick={() => handleDeleteNote(index)}
                                        >
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='18'
                                            height='18'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='currentColor'
                                            stroke-width='2'
                                            stroke-linecap='round'
                                            stroke-linejoin='round'
                                            className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-2 mb-1'
                                          >
                                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                            <path d='M4 7l16 0' />
                                            <path d='M10 11l0 6' />
                                            <path d='M14 11l0 6' />
                                            <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                            <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                          </svg>
                                          Delete
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                {editingNoteIndex === index ? (
                                  <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <textarea
                                      value={editedNoteContent}
                                      onChange={(e) => setEditedNoteContent(e.target.value)}
                                      className='form-control'
                                    />
                                    <div
                                      className='d-flex justify-content-end w-100 mt-2 gap-2'
                                      style={{width: '100%'}}
                                    >
                                      <Button
                                        btnType='secondary'
                                        onClick={() => setEditingNoteIndex(null)}
                                      >
                                        Close
                                      </Button>
                                      <button
                                        onClick={handleSaveEditedNote}
                                        className='btn btn-sm fs-6'
                                        onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                                          (e.currentTarget.style.backgroundColor = '#148363')
                                        }
                                        onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                                          (e.currentTarget.style.backgroundColor = '#0E9F6E')
                                        }
                                        style={{
                                          backgroundColor: '#0E9F6E',
                                          color: '#fff',
                                          height: '40px',
                                          borderRadius: '4px',
                                          marginLeft: '4px',
                                          transition: 'background-color 0.3s',
                                        }}
                                      >
                                        {noteSaving ? (
                                          <>
                                            Saving...
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                          </>
                                        ) : (
                                          'Save'
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className='card p-4 mt-2'>
                                    <span className='d-block fs-6 text-gray-900'>{note.note}</span>
                                  </div>
                                )}
                              </div>
                            ))
                          ) : (
                            <div
                              className='d-flex justify-content-center align-items-center text-center'
                              style={{height: '100%'}}
                            >
                              <div className=''>
                                <img
                                  src='/media/buttons/emptystate.svg'
                                  alt=''
                                  className='img-fluid'
                                  style={{maxWidth: '100px'}}
                                />

                                <div className=' fs-6'>
                                  <p style={{fontWeight: 'bold'}}>No notes added yet!!</p>
                                </div>
                                <p className='fs-7'>Maybe try adding new note for this control </p>
                              </div>
                            </div>
                          )
                        })
                      ) : (
                        <div>No controls available</div>
                      )}
                    </div>
                  </>
                )}

                {activeTab === 'risks' && (
                  <>
                    {' '}
                    <div className='my-4 d-flex justify-content-between'>
                      <div className=''>
                        <div className='fs-6 fw-bold mb-2'>Risk Scenarios</div>
                        <span>
                          {control?.risk_scenario ? control?.risk_scenario.length : 0} scenarios
                          mapped to this control
                        </span>
                      </div>
                      <button
                        className='btn btn-sm fs-6'
                        onClick={handleOpenRisk}
                        onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                          (e.currentTarget.style.backgroundColor = '#148363')
                        }
                        onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                          (e.currentTarget.style.backgroundColor = '#0E9F6E')
                        }
                        style={{
                          backgroundColor: '#0E9F6E',
                          color: '#fff',
                          width: '130px',
                          height: '40px',
                          borderRadius: '4px',
                          marginRight: '0px',
                          transition: 'background-color 0.3s',
                        }}
                        disabled={currentUser?.role === 'Auditor' || !!currentAuditContext}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='18'
                          height='18'
                          viewBox='0 0 24 24'
                          fill='none'
                          stroke='currentColor'
                          stroke-width='2'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                          className='icon icon-tabler icons-tabler-outline icon-tabler-plus me-1 mb-1'
                        >
                          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                          <path d='M12 5l0 14' />
                          <path d='M5 12l14 0' />
                        </svg>
                        Add Risks
                      </button>
                    </div>
                    <div className='card mt-4'>
                      <div
                        className='table-responsive'
                        style={{minHeight: '100px', maxHeight: '500px', overflowY: 'auto'}}
                      >
                        {control?.risk_scenario && control?.risk_scenario.length > 0 ? (
                          <table className='table table-row-dashed table-row-gray-300 align-middle gs-6 gy-6'>
                            {/* begin::Table head */}
                            <thead>
                              <tr
                                className='fw-bold'
                                style={{background: '#F6F6F6', color: '#5A5A5A'}}
                              >
                                <th className='min-w-200px pe-6'>Scenario</th>
                                <th className='min-w-100px'>Status</th>
                                <th className='min-w-50px'>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {control?.risk_scenario.map((control) => (
                                <tr key={control.riskId} className=' px-6'>
                                  <td
                                    className='fs-6 fw-semibold text-hover-primary py-8'
                                    style={{borderBottom: '1px dotted #C5C5C5', cursor: 'pointer'}}
                                    onClick={() => handleRiskClick(control.riskId)}
                                  >
                                    {control.riskSource}
                                  </td>
                                  <td>
                                    {' '}
                                    <span
                                      className={`badge fs-7 ${
                                        control.status === 'Incomplete'
                                          ? 'badge-danger'
                                          : control.status === 'Needs approval'
                                          ? 'badge-warning'
                                          : 'badge-primary'
                                      }`}
                                      style={{
                                        color:
                                          control.status === 'Incomplete'
                                            ? '#EE3043'
                                            : control.status === 'Needs approval'
                                            ? '#FFA800'
                                            : '#0E9F6E',
                                        background:
                                          control.status === 'Incomplete'
                                            ? '#FFF5F8'
                                            : control.status === 'Needs approval'
                                            ? '#FFF8DD'
                                            : '#E8F8F4',
                                      }}
                                    >
                                      {control.status}
                                    </span>
                                  </td>
                                  <td>
                                    <button
                                      className='btn btn-sm btn-icon btn-secondary ms-2'
                                      onClick={() => handleDeleteControl(control)}
                                      disabled={currentUser?.role === 'Auditor' || !!currentAuditContext}
                                      style={{flexShrink: 0}}
                                      onMouseEnter={(e) => {
                                        const svg = e.currentTarget.querySelector('svg')
                                        if (svg) {
                                          svg.style.stroke = 'oklch(57.7% 0.245 27.325)'
                                        }
                                      }}
                                      onMouseLeave={(e) => {
                                        const svg = e.currentTarget.querySelector('svg')
                                        if (svg) {
                                          svg.style.stroke = 'currentColor'
                                        }
                                      }}
                                    >
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='18'
                                        height='18'
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        stroke='currentColor'
                                        strokeWidth='2'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        className='icon icon-tabler icons-tabler-outline icon-tabler-trash'
                                        style={{
                                          transition: 'stroke 0.2s',
                                        }}
                                      >
                                        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                        <path d='M4 7l16 0' />
                                        <path d='M10 11l0 6' />
                                        <path d='M14 11l0 6' />
                                        <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                        <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                      </svg>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <>
                            <div
                              className='card-body'
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='24'
                                height='24'
                                viewBox='0 0 24 24'
                                fill='none'
                                stroke='#000'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                className='icon icon-tabler icons-tabler-outline icon-tabler-adjustments-horizontal'
                              >
                                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                <path d='M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                                <path d='M4 6l8 0' />
                                <path d='M16 6l4 0' />
                                <path d='M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                                <path d='M4 12l2 0' />
                                <path d='M10 12l10 0' />
                                <path d='M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
                                <path d='M4 18l11 0' />
                                <path d='M19 18l1 0' />
                              </svg>
                              <br />
                              <span className='fs-6 fw-semibold'>No risks added</span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {activeTab === 'tasks' && (
                  <>
                    <div className='card px-6 mt-4'>
                      <div className='my-4 d-flex justify-content-between'>
                        <div className='my-4'>
                          <div className='fs-6 fw-bold mb-2'>Task List</div>
                          <span>Assign tasks that might fix this control to team members.</span>
                        </div>
                        <button
                          className='btn btn-sm my-4'
                          onClick={handleOpenModal}
                          onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
                            (e.currentTarget.style.backgroundColor = '#ECECEC')
                          }
                          onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
                            (e.currentTarget.style.backgroundColor = '#fff')
                          }
                          // disabled={activities.length === 0}
                          style={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: '120px',
                            height: '40px',
                            borderRadius: '4px',
                            border: '2px solid #C5C5C5',
                            transition: 'background-color 0.3s',
                          }}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            stroke-width='2'
                            stroke-linecap='round'
                            stroke-linejoin='round'
                            className='icon icon-tabler icons-tabler-outline icon-tabler-plus mx-1'
                          >
                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                            <path d='M12 5l0 14' />
                            <path d='M5 12l14 0' />
                          </svg>
                          Add Task
                        </button>
                      </div>
                      <div
                        className='table-responsive'
                        style={{minHeight: '300px', maxHeight: '500px', overflowY: 'auto'}}
                      >
                        {/* begin::Table */}
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                          {/* begin::Table head */}
                          <thead>
                            <tr className='fw-bold text-muted'>
                              <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    value='1'
                                    data-kt-check='true'
                                    data-kt-check-target='.widget-9-check'
                                    // checked={isChecked}
                                    // onChange={handleCheckboxChange}
                                  />
                                </div>
                              </th>
                              <th className='min-w-200px'>Task</th>
                              <th className='min-w-50px'>Priority</th>
                              <th className='min-w-100px'>Assigned To</th>
                              {/* <th className='min-w-100px'>Due date</th> */}
                              <th className='min-w-50px text-end'></th>
                            </tr>
                          </thead>
                          {/* end::Table head */}
                          {/* begin::Table body */}
                          <tbody>
                            {tasks.map((task) => (
                              <tr key={task.id}>
                                <td>
                                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                    <input
                                      className='form-check-input widget-9-check'
                                      type='checkbox'
                                      checked={task.checked}
                                      // onChange={() => handleTaskCheckboxChange(task.id)}
                                    />
                                  </div>
                                </td>

                                <td>
                                  <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                    {task.taskName}
                                  </div>
                                </td>
                                <td>
                                  <span className='badge border p-2 rounded-pill fs-6 fw-semibold'>
                                    <span
                                      className={`badge border rounded-circle mx-2  ${
                                        task.priority === 'High'
                                          ? 'bg-danger'
                                          : task.priority === 'Medium'
                                          ? 'bg-warning'
                                          : 'bg-primary'
                                      }
                           `}
                                      style={{
                                        width: '12px',
                                        height: '12px',
                                        padding: '3px',
                                      }}
                                    >
                                      {' '}
                                    </span>

                                    {task.priority}
                                  </span>
                                </td>
                                <td>
                                  <div className='d-flex align-items-center'>
                                    {task.owner ? (
                                      <>
                                        <div className='symbol symbol-35px me-3'>
                                          <span
                                            className='symbol-label fs-7 fw-bold'
                                            style={{backgroundColor: '#DAF9EF'}}
                                          >
                                            {task.owner
                                              ? (() => {
                                                  const nameParts = task.owner.split(' ')
                                                  if (nameParts.length > 1) {
                                                    return `${nameParts[0]
                                                      .charAt(0)
                                                      .toUpperCase()}${nameParts[1]
                                                      .charAt(0)
                                                      .toUpperCase()}`
                                                  } else {
                                                    return `${nameParts[0]
                                                      .charAt(0)
                                                      .toUpperCase()}${nameParts[0]
                                                      .charAt(1)
                                                      .toUpperCase()}`
                                                  }
                                                })()
                                              : ''}
                                          </span>
                                        </div>
                                        <div className='d-flex justify-content-start flex-column'>
                                          <div className='text-dark fw-semibold text-hover-primary fs-6'>
                                            {task.owner}
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <span>-</span>
                                      </>
                                    )}
                                  </div>
                                </td>

                                <td className='text-end'>
                                  <div className='dropdown '>
                                    <button
                                      className='btn btn-secondary border-0 p-0 '
                                      type='button'
                                      id='dropdownMenu2'
                                      data-bs-toggle='dropdown'
                                      aria-haspopup='true'
                                      aria-expanded='false'
                                    >
                                      <img
                                        src='/media/buttons/Options.svg'
                                        alt='Options'
                                        // onClick={toggleDropdown}
                                      />
                                    </button>
                                    <ul className='dropdown-menu' aria-labelledby='dropdownMenu2'>
                                      <li>
                                        <button
                                          className='dropdown-item'
                                          type='button'
                                          // onClick={() => handleMarkAsComplete(task.id)}
                                        >
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='18'
                                            height='18'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='#5E6274'
                                            strokeWidth='2'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            className='icon icon-tabler icons-tabler-outline icon-tabler-check mx-1 mb-1'
                                          >
                                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                            <path d='M5 12l5 5l10 -10' />
                                          </svg>{' '}
                                          Mark as complete
                                        </button>
                                      </li>
                                      <li>
                                        <button
                                          className='dropdown-item'
                                          style={{color: '#F15363'}}
                                          type='button'
                                          onClick={() => handleRemoveTask(task.id)}
                                        >
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            width='18'
                                            height='18'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='#F15363'
                                            strokeWidth='2'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            className='icon icon-tabler icons-tabler-outline icon-tabler-trash mx-1 mb-1'
                                          >
                                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                                            <path d='M4 7l16 0' />
                                            <path d='M10 11l0 6' />
                                            <path d='M14 11l0 6' />
                                            <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                                            <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                                          </svg>{' '}
                                          Remove task
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
        </div>
        {activeTab === 'notes' && (
          <div
            className='offcanvas-footer  border-top pt-4 pb-4  px-6'
            style={{position: 'sticky', bottom: 0, backgroundColor: 'white'}}
          >
            <div className='d-flex align-items-center'>
              <input
                type='text'
                className='form-control me-2'
                placeholder='Leave a note'
                name='notes'
                value={noteInput}
                onChange={(e) => setNoteInput(e.target.value)}
              />
              {isAdding ? (
                <Button
                  btnType='primary'
                  disabled
                >
                  Adding...{' '}
                  <span className='spinner-border spinner-border-sm align-middle m-2'></span>
                </Button>
              ) : (
                <Button btnType='primary' onClick={handleNotes} disabled={!noteInput.trim()}>
                  Add Note
                </Button>
              )}
            </div>
          </div>
        )}
      </Drawer>
      <UpgradePlanTest show={showModal2} onClose={() => setShowModal2(false)} />
      <ConfirmationModal
        isModalOpen={isTaskDeleteModalOpen}
        hideModal={() => setIsTaskDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmTaskDelete}
        toDeleteItemTitle='selected task'
        isLoading={isDeleting}
        title='Remove Task'
        message='Are you sure you want to remove the selected task? This action cannot be undone.'
        type='delete'
      />

      <ConfirmationModal
        isModalOpen={isControlDeleteModalOpen}
        hideModal={() => setIsControlDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmControlDelete}
        toDeleteItemTitle={selectedRisk?.riskSource}
        isLoading={isDeleting}
        title='Remove Control from Risk Scenario'
        message={`Are you sure you want to remove ${selectedRisk?.riskSource} control from risk scenario? This action cannot be undone.`}
        type='delete'
      />
      <ConfirmationModal
        isModalOpen={isNoteDeleteModalOpen}
        hideModal={() => setIsNoteDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmNoteDelete}
        toDeleteItemTitle='note'
        isLoading={isDeleting}
        title='Delete Note'
        message='Are you sure you want to delete this note? This action cannot be undone.'
        type='delete'
      />

      <ConfirmationModal
        isModalOpen={isTestDeleteModalOpen}
        hideModal={() => setIsTestDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmTestDelete}
        toDeleteItemTitle='test document'
        isLoading={isDeleting}
        title='Delete Test Document'
        message='Are you sure you want to delete this test document? This action cannot be undone.'
        type='delete'
      />

      <ConfirmationModal
        isModalOpen={isPlatformDeleteModalOpen}
        hideModal={() => setIsPlatformDeleteModalOpen(false)}
        confirmBtnClickHandler={handleConfirmPlatformDelete}
        toDeleteItemTitle='platform test'
        isLoading={isDeleting}
        title='Delete Platform Test'
        message='Are you sure you want to delete this platform test? This action cannot be undone.'
        type='delete'
      />
    </>
  )
}

export {ViewControl}
